(function () {
  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function disableFancyboxInProductGalleryOnMobile() {
    if (!isMobile()) return;

    document.querySelectorAll('.product_gallery a.lightbox[data-fancybox]').forEach(function (a) {
      a.removeAttribute('data-fancybox');
      a.removeAttribute('rel');
      a.classList.remove('lightbox');

      a.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
      }, { passive: false });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', disableFancyboxInProductGalleryOnMobile);
  } else {
    disableFancyboxInProductGalleryOnMobile();
  }
})();